import { useMemo } from 'react'
import useMedia from 'use-media'
import { object, array, bool } from 'prop-types'

import { FILTERS } from '@/constants'
import { useEnhancedList } from '@/context/EnhancedList'
import {
  getLanguagesFilterConfig,
  getIndustriesFilterConfig,
  getServicesFilterConfig,
  getCountriesFilterConfig,
} from '@/utils/products'
import mediaQueries from '@/layout/media-queries'
import styles from '@/layout/category-styles'
import ListHeader from '@/components/ProductList/Header'
import AppsSection from '@/components/Category/AppsSection'

import Sidebar from './Sidebar'
import ExpertListVertical from './ExpertListVertical'
import { isAgentApp } from '@/utils'

const SERVICES_LIST_FILTERS_KEY = 'SERVICES_LIST_FILTERS'
const NUMBER_OF_EXPERT_CAMPAIGNS = 3
const IS_CAMPAIGN_COUNT_ODD_NUMBER = NUMBER_OF_EXPERT_CAMPAIGNS % 2 !== 0

const Experts = ({ campaign, featured, hideServicesFilter }) => {
  const { title, description, name } = campaign

  const { items, filters, updateFilters, filtersOptions } = useEnhancedList()

  const isServicesFilterNotVisible = useMedia({
    maxWidth: mediaQueries.BASE_MEDIUM_SIZE - 1,
  })

  const filtersConfig = useMemo(() => {
    const languageOptions = filtersOptions[FILTERS.LANGUAGE.ID] || []
    const countryOptions = filtersOptions[FILTERS.COUNTRY.ID] || []
    const industryOptions = filtersOptions[FILTERS.INDUSTRY.ID] || []

    const defaultConfig = [
      getLanguagesFilterConfig(filters, updateFilters, languageOptions),
      getCountriesFilterConfig(filters, updateFilters, countryOptions),
      getIndustriesFilterConfig(filters, updateFilters, industryOptions),
    ]

    if ((isAgentApp || isServicesFilterNotVisible) && !hideServicesFilter) {
      const servicesOptions = filtersOptions[FILTERS.SERVICE.ID] || []

      return [
        getServicesFilterConfig(filters, updateFilters, servicesOptions),
        ...defaultConfig,
      ]
    }

    return defaultConfig
  }, [
    filters,
    updateFilters,
    isServicesFilterNotVisible,
    hideServicesFilter,
    filtersOptions,
  ])

  return (
    <div css={styles.category}>
      <div className="content">
        <Sidebar
          updateFilters={updateFilters}
          filters={filters}
          className="sidebar"
        />

        <div className="body">
          {featured && featured.length > 0 && (
            <AppsSection
              isFeatured
              listComponent={ExpertListVertical}
              items={featured.slice(0, NUMBER_OF_EXPERT_CAMPAIGNS)}
              css={styles.featuredCategories(IS_CAMPAIGN_COUNT_ODD_NUMBER)}
            >
              <div className="name">
                <h1 className="title">{`Featured in ${name}`}</h1>
              </div>
            </AppsSection>
          )}

          <AppsSection items={items} listComponent={ExpertListVertical}>
            <ListHeader
              storageKey={SERVICES_LIST_FILTERS_KEY}
              filters={filtersConfig}
              title={title}
              subtitle={description}
            />
          </AppsSection>
        </div>
      </div>
    </div>
  )
}

Experts.propTypes = {
  campaign: object,
  featured: array,
  hideServicesFilter: bool,
}

export default Experts
